/* import __COLOCATED_TEMPLATE__ from './link-to-news-center-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();